import React from 'react';
import { IconProps } from '../types/types';

const MA: React.FC<IconProps> = (props) => (
    <svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" role="img" {...props}><path fill="url(#paint0_linear)" d="M0 0h18v18H0z"/><circle cx="7" cy="9" r="3" fill="#EB001B"/><circle cx="11" cy="9" r="3" fill="#F79E1B"/><path d="M9 11.236c.614-.55 1-1.347 1-2.236 0-.888-.386-1.687-1-2.236-.614.55-1 1.348-1 2.236 0 .889.386 1.687 1 2.236z" fill="#FF5F00"/><defs><linearGradient id="paint0_linear" x1="3.349" y1="3.122" x2="21.904" y2="24.434" gradientUnits="userSpaceOnUse"><stop stopColor="#1A1E21"/><stop offset="1" stopColor="#06060A"/></linearGradient></defs></svg>
);

export default MA;